define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.resolveCssVarValue = exports.makeCssVarValue = exports.makeCssVariableName = void 0;
    const makeCssVariableName = (applicationPrefix, varPrefix, varName) => {
        let elts = varName.split(".");
        elts = elts.map(varName => { return varName.replace(/[A-Z]/g, ch => "-" + ch.toLowerCase()); });
        return `--${applicationPrefix ? `${applicationPrefix}-` : ''}${varPrefix}${elts.join("-")}`;
    };
    exports.makeCssVariableName = makeCssVariableName;
    const makeCssVarValue = (applicationPrefix, varPrefix, value) => {
        if (typeof value === 'object' && "var" in value) {
            return `var(${(0, exports.makeCssVariableName)(applicationPrefix, varPrefix, value.var)})`;
        }
        if (typeof value !== 'string') {
            return "";
        }
        return value;
    };
    exports.makeCssVarValue = makeCssVarValue;
    const resolveCssVarValue = (value, themeDescriptor) => {
        if (typeof value == "string" || typeof value == "number") {
            return value;
        }
        if (typeof value === 'object' && "var" in value) {
            let path = value.var;
            if (typeof path == "string") {
                var resolvedValue = path.split('.').reduce((acc, key) => acc === null || acc === void 0 ? void 0 : acc[key], themeDescriptor.themes.base);
                if (typeof resolvedValue === 'object' && "var" in resolvedValue) {
                    return (0, exports.resolveCssVarValue)(resolvedValue, themeDescriptor);
                }
                if (typeof resolvedValue == "string" || typeof resolvedValue == "number") {
                    return resolvedValue;
                }
            }
        }
        return "";
    };
    exports.resolveCssVarValue = resolveCssVarValue;
});
